const style = (theme) => {
  const output = {
    root: {
      width: '100%',
      height: '100%',
      position: 'fixed',
      left: '0',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 101,
    },
    container: {
      width: '22%',
      // height: '55%',
      // paddingTop: '100%',
      position: 'relative',
      zIndex: 10,
      '& a': {
        display: 'block',
        width: '100%',
        paddingTop: '100%',
        position: 'relative',
        // height: '100%',
      },
    },
    image: {
      width: '100%',
      height: '100%',
      overflow: 'hidden',
      borderRadius: 30,
      position: 'absolute',
      top: 0,
      left: 0,
      '& img': {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      },
    },
    background: {
      backgroundColor: 'rgba(0,0,0,0.6)',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      zIndex: 9,
    },
    btnClose: {
      display: 'block',
      position: 'absolute',
      top: -45,
      right: 0,
      // padding: theme.header.spacing,
      // paddingBottom: 0,
      fontFamily: theme.fonts[0],
      fontSize: 24,
      color: theme.colors[1],
      // transformOrigin: 'bottom center',
      cursor: 'pointer',
      padding: 0,
      '&:before': {
        content: '""',
        display: 'block',
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%',
        height: 1,
        background: theme.colors[1],
        transform: 'scaleX(0)',
        transformOrigin: 'center right',
        transition: 'transform 0.8s cubic-bezier(0.19, 1, 0.22, 1)',
      },
      '&:hover': {
        '&:before': {
          transform: 'scaleX(1)',
          transformOrigin: 'center left',
        },
      },
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    container: {
      width: '70%',
    },
    btnClose: {
      top: -32,
      right: 0,
      fontSize: 18,
    },
  }

  return output
}

export default style
